import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/providers/AuthProvider";
import styles from "./ManagementHeader.module.css";
import Logo from "@/components/common/logo/Logo";
import Button from "@/components/common/button/Button";
import { LogOut, User } from "lucide-react";
import type { managementHeaderProps } from "./types.props";

const ManagementHeader: React.FC<managementHeaderProps> = ({
    linkTo = "/facilitator-panel",
    showBackButton = true,
    showLogout = true,
    showProfile = false,
}) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    return (
        <header className={styles["header-nav"]}>
            <Logo to={linkTo} className={styles.logo} />

            <div className={styles.wrapper}>
                {showBackButton && (
                    <Button
                        variant="secondary"
                        className={styles["nav-btn"]}
                        onClick={() => navigate(linkTo)}
                    >
                        Volver
                    </Button>
                )}
                {showProfile && (
                    <Button
                        variant="secondary"
                        className={styles["nav-btn"]}
                        onClick={() => navigate("/mis-datos")}
                        leftIcon={<User size={16} />}
                    >
                        Mis datos
                    </Button>
                )}
                {showLogout && (
                    <Button
                        variant="secondary"
                        className={styles["nav-btn"]}
                        onClick={logout}
                        leftIcon={<LogOut size={16} />}
                    >
                        Cerrar sesión
                    </Button>
                )}
            </div>
        </header>
    );
};

export default ManagementHeader;
